import Vue from 'vue'

import WalkDashboard from './WalkDashboard.vue';

Vue.component('module-walk-dashboard', WalkDashboard)